import {  SlotGameType1_3 } from "../SlotGameType1_3";
export class LuckyIce103 extends SlotGameType1_3{ }